module.exports = {
  DEFAULT_REQ_OPTS: { response: true },
}
